<template>
  <v-container>
    <v-row>
      <v-col class="text-center">
        <h1>Feature Demos</h1>
      </v-col>
    </v-row>
    <v-row align="center">
      <v-col class="text-center">
        <h3>App Notification / Alert</h3>
        <pre>$app.alert('Alert Demo')</pre>

        <v-btn class="my-2" color="blue" @click="$app.alert('Alert Demo')"
          >Send Alert</v-btn
        >
        <br />
        <v-btn class="my-2" color="blue" @click="$app.alert2('Alert Demo')"
          >Send Alert 2</v-btn
        >
        <br />
        <v-btn class="my-2" color="blue" @click="$app.alert2('clear')"
          >Clear All</v-btn
        >
      </v-col>
      <v-col class="text-center">
        <h3>Top Tool Bar Show/HIde</h3>
        <pre>$app.topToolBar.show</pre>
        <div class="my-2">
          <v-btn
            color="purple"
            @click="$app.topToolBar.show = !$app.topToolBar.show"
            >Show/Hide Top Toolbar</v-btn
          >
        </div>
      </v-col>
      <v-col class="text-center">
        <h3>System Bar</h3>
        <pre>$app.systemBar.show</pre>
        <div class="my-2">
          <v-btn
            color="orange"
            @click="$app.systemBar.show = !$app.systemBar.show"
            >Show/Hide System Bar</v-btn
          >
        </div>
      </v-col>
      <v-col>
        <div
          id="L79NDXhXI"
          role="status"
          aria-live="polite"
          aria-atomic="false"
          class="toasted-container top-right"
        >
          <div
            class="toasted WolfClass toasted-primary default"
            style="touch-action: pan-y; user-select: none; -webkit-user-drag: none; -webkit-tap-highlight-color: rgba(0, 0, 0, 0); opacity: 1; transform: translateY(-35px);"
          >
            <h1>Alert Demo</h1>
            <a class="action ripple">Cancel</a><a class="action ripple">Undo</a>
          </div>
          <v-alert class="my-2" type="success">Vuetify</v-alert>
          <v-alert class="my-2" type="info"
            >Info Alert
            <v-btn dark text>
              Close
            </v-btn>
          </v-alert>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Features",
  route: {
    path: "/demos/",
    name: "Feature Demos",
  },
};
</script>

<style>
.red {
  background: red;
}

.toasted-primary {
  background: none;
}
</style>
